export function getQueryParams(): Record<string, string> {
  const params: Record<string, string>= {};
  const queryString = window.location.search.substring(1);
  const queryArray = queryString.split('&');

  queryArray.forEach(param => {
    const [key, value] = param.split('=');
    params[key] = decodeURIComponent(value);
  });

  return params;

}
